import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons

import {
    // faAt,
    // faArrowDown,
    // faArrowUp,
    //
    // faBan,
    // faBars,
    // faBell,
    // faBook,
    // faBox,
    //
    // faCalculator,
    // faCalendar,
    // faCaretDown,
    // faCaretUp,
    // faCartPlus,
    // faCheck,
    // faCheckCircle,
    // faChevronDown,
    // faChevronLeft,
    // faChevronRight,
    // faChevronUp,
    // faCircle,
    // faClipboard,
    // faClone,
    // faCreditCard,
    // faCogs,
    // faComments,
    // faCopy,
    // faCube,
    // faCubes,
    //
    // faDolly,
    // faDownload,
    //
    // faEllipsisV,
    // faEnvelope,
    // faEnvelopeOpen,
    // faEuroSign,
    // faExclamationCircle,
    // faExclamationTriangle,
    // faExternalLinkAlt,
    // faEye,
    // faEyeSlash,
    //
    // faFile,
    // faFileDownload,
    // faFileImage,
    // faFileInvoice,
    // faFileUpload,
    // faFilter,
    // faFolderOpen,
    // faForward,
    // faFrown,
    //
    // faGavel,
    // faGear,
    // faGears,
    // faGift,
    //
    // faHandPointer,
    // faHistory,
    //
    // faImage,
    // faInfo,
    // faInfoCircle,
    //
    // faLightbulb,
    // faList,
    // faLock,
    // faLongArrowAltDown,
    // faLongArrowAltUp,
    //
    // faMap,
    // faMapMarker,
    // faMapMarkerAlt,
    // faMapSigns,
    // faMinus,
    // faMoneyBillAlt,
    //
    // faPaperPlane,
    // faPauseCircle,
    // faPen,
    // faPercent,
    // faPiggyBank,
    // faPhone,
    // faPlus,
    // faPowerOff,
    // faPrint,
    //
    // faQuestionCircle,
    //
    // faRecycle,
    // faRedo,
    // faRedoAlt,
    // faReply,
    //
    // faSave,
    // faSearch,
    // faShoppingBasket,
    // faSignInAlt,
    // faSlidersH,
    // faSmile,
    // faSortAmountDown,
    // faSortAmountUp,
    // faSpinner,
    // faStar,
    // faStickyNote,
    // faSync,
    // faSyncAlt,
    //
    // faTachometerAlt,
    // faTag,
    // faTags,
    // faTerminal,
    // faThumbsUp,
    // faThumbtack,
    // faTimes,
    // faTimesCircle,
    // faToggleOn,
    // faToggleOff,
    // faTrash,
    // faTrashAlt,
    // faTruck,
    //
    // faUndo,
    // faUnlock,
    // faUnlockAlt,
    // faUserCircle,
    // faUserPlus,
    // faUser,
    // faUsers,
    // faUserShield,
    // faUserSlash,
    // faUserTag,
    // faUserTimes,
    //
    // faWaveSquare,

    // Global
    fas
} from '@fortawesome/free-solid-svg-icons';

// import {
//     faFacebook,
// } from '@fortawesome/free-brands-svg-icons';

library.add(
    // Global
    fas,

    // more icons go here

    // faAt,
    // faArrowDown,
    // faArrowUp,
    //
    // faBan,
    // faBars,
    // faBell,
    // faBook,
    // faBox,
    //
    // faCalculator,
    // faCalendar,
    // faCaretDown,
    // faCaretUp,
    // faCartPlus,
    // faCheck,
    // faCheckCircle,
    // faChevronDown,
    // faChevronLeft,
    // faChevronRight,
    // faChevronUp,
    // faCircle,
    // faClipboard,
    // faClone,
    // faCreditCard,
    // faChevronLeft,
    // faCogs,
    // faComments,
    // faCopy,
    // faCube,
    // faCubes,
    //
    // faDolly,
    // faDownload,
    //
    // faEllipsisV,
    // faEnvelope,
    // faEnvelopeOpen,
    // faEuroSign,
    // faExclamationCircle,
    // faExclamationTriangle,
    // faExternalLinkAlt,
    // faEye,
    // faEyeSlash,
    //
    // // faFacebook,
    // faFile,
    // faFileDownload,
    // faFileImage,
    // faFileInvoice,
    // faFileUpload,
    // faFilter,
    // faFolderOpen,
    // faForward,
    // faFrown,
    //
    // faGavel,
    // faGear,
    // faGears,
    // faGift,
    //
    // faHandPointer,
    // faHistory,
    //
    // faImage,
    // faInfo,
    // faInfoCircle,
    //
    // faLightbulb,
    // faList,
    // faLock,
    // faLongArrowAltDown,
    // faLongArrowAltUp,
    //
    // faMap,
    // faMapMarker,
    // faMapMarkerAlt,
    // faMapSigns,
    // faMinus,
    // faMoneyBillAlt,
    //
    // faPaperPlane,
    // faPauseCircle,
    // faPen,
    // faPercent,
    // faPiggyBank,
    // faPhone,
    // faPlus,
    // faPowerOff,
    // faPrint,
    //
    // faQuestionCircle,
    //
    // faRecycle,
    // faRedo,
    // faRedoAlt,
    // faReply,
    //
    // faSave,
    // faSearch,
    // faShoppingBasket,
    // faSignInAlt,
    // faSlidersH,
    // faSmile,
    // faSortAmountDown,
    // faSortAmountUp,
    // faSpinner,
    // faStar,
    // faStickyNote,
    // faSync,
    // faSyncAlt,
    //
    // faTachometerAlt,
    // faTag,
    // faTags,
    // faTerminal,
    // faThumbsUp,
    // faThumbtack,
    // faTimes,
    // faTimesCircle,
    // faToggleOn,
    // faToggleOff,
    // faTrash,
    // faTrashAlt,
    // faTruck,
    //
    // faUndo,
    // faUnlock,
    // faUnlockAlt,
    // faUserCircle,
    // faUserPlus,
    // faUser,
    // faUsers,
    // faUserShield,
    // faUserSlash,
    // faUserTag,
    // faUserTimes,
    //
    // faWaveSquare,
);
